import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, Renderer2, computed, effect, forwardRef, inject, input, model, output, signal, viewChild } from '@angular/core';
import { Collection, Feature, Map as olMap } from 'ol';
import VectorSource from 'ol/source/Vector';
import { ESKTOOL_TOKEN, EskTool } from '../../util/esk-tool-interface';
import { Interaction, Modify } from 'ol/interaction';
import { ModifyEvent } from 'ol/interaction/Modify';
import { TooltipDirective } from 'src/app/shared/directives/tooltip/tooltip.directive';
import { Difference, Intersect, Intersects } from 'src/app/shared/helpers/transformations';
import VectorLayer from 'ol/layer/Vector';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { primaryAction } from 'ol/events/condition';
import { LineString, Polygon } from 'ol/geom';
import { EventsKey } from 'ol/events';
import { DifferenceToolDirective } from '../difference/difference.directive';
import { IntersectToolDirective } from '../intersect-tool/intersect.directive';

const baseClasses = ['flex','gap-2',]

@Component({
    selector: 'map-modify',
    templateUrl: './modify.component.html',
    styleUrls: ['./modify.component.css'],
    imports: [CommonModule, TooltipDirective, ReactiveFormsModule, MatMenuModule, MatCheckboxModule, DifferenceToolDirective, IntersectToolDirective],
    providers: [
        { provide: ESKTOOL_TOKEN, useExisting: forwardRef(() => ModifyComponent) }
    ],
    host: {
        '[class]': '_computedClass()',
    }
})
export class ModifyComponent implements OnInit, OnDestroy, EskTool  {

  private renderer: Renderer2 = inject(Renderer2);

  active = model(false);

  differenceTargetLayers = input<Array<VectorLayer<any>>>([]);
  intersectTargetLayers = input<Array<VectorLayer<any>>>([]);
  intersectTargetFeatures = input<Array<Feature<any>>>([]);

    differenceTool = viewChild(DifferenceToolDirective);
    intersectTool = viewChild(IntersectToolDirective);

  protected activeClasses = computed(() =>
  {
    const active = this.active();

    const activeClasses = ['border', 'border-gray-400', 'rounded-lg', 'px-1', 'shadow-inner', 'shadow-gray-500/30', 'bg-gray-100'];

    return active ? activeClasses : '';
  }
  )


  protected _computedClass = computed(() =>
    {
      const activeClasses = this.activeClasses();


      return   [...baseClasses,...activeClasses].join(' ');
    }
	);


  shouldRemove = input<boolean>(false);

  map = input.required<olMap>();

  source = input( new VectorSource());

  modifyEnd = output<Feature>();

  private contextmenuListener: EventListener;

  modifyInteraction = computed(() => {

      const source = this.source();

      const modifyInteraction = new Modify({
          source: source,
      });

      modifyInteraction.on('modifyend', (event: ModifyEvent) => {

        let feature = event.features.pop();

        if(feature == null)
          {
            return;
          }

          const differenceTool = this.differenceTool();

          if(differenceTool != null)
          {
            differenceTool.execute(feature);
          }

          const intersectTool = this.intersectTool();

          if(intersectTool != null)
          {
            intersectTool.execute(feature);
          }

          this.modifyEnd.emit(feature)

      });



      return modifyInteraction;

  });



  constructor() {
    effect(() => {

      const active = this.active();
      const shouldRemove = this.shouldRemove();
      const modifyInteraction = this.modifyInteraction();

      if(modifyInteraction == null)
      {
        return;
      }

        if(!active || shouldRemove)
          {
            this.map().removeInteraction(modifyInteraction);
            document.removeEventListener('contextmenu', this.contextmenuListener);
            return;
          }

      document.addEventListener('contextmenu', this.contextmenuListener);

      this.map().addInteraction(modifyInteraction);

    },{allowSignalWrites: true});


   }



  ngOnInit() {
    this.contextmenuListener = (event: MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();

    };


  }

  ngOnDestroy(): void {
      const modifyInteraction = this.modifyInteraction();

      if(modifyInteraction != null)
        {
          this.map().removeInteraction(modifyInteraction);
        }

        if (this.contextmenuListener) {
          document.removeEventListener('contextmenu', this.contextmenuListener);
        }

  }


  toggleTool()
  {
    this.active.set(!this.active());
  }
}
